<template>
  <div
    class="border-bottom mt-2 no-border-last-child"
    :class="{ deleteMe: option.$model.delete_me }"
  >
    <b-row class="d-flex align-items-center mb-2">
      <b-col>Option #{{ index }}</b-col>
      <b-col>
        <b-button v-if="option.$model.delete_me" @click="onCancelRemove">
          Cancel Remove
        </b-button>
        <b-button v-else @click="onRemoveOption" variant="primary" size="sm">
          Remove Option
        </b-button>
      </b-col>
    </b-row>
    <b-form-group
      horizontal
      label="Option Text:"
      label-cols="4"
      :invalid-feedback="invalidFeedback"
    >
      <b-form-input
        v-model="option.name.$model"
        :state="validateState('name')"
      />
    </b-form-group>
    <b-form-group
      horizontal
      label="Option Value:"
      label-cols="4"
      :invalid-feedback="invalidFeedback"
    >
      <b-form-input
        v-model="option.value.$model"
        :state="validateState('value')"
      />
    </b-form-group>
  </div>
</template>

<script>
export default {
    name: 'VariableOption',
  props: {
    index: [String, Number],
    option: {
      type: Object,
      required: true,
    },
  },
  computed: {
    invalidFeedback: function () {
      return 'This field is required';
    },
    optionId: function () {
      return this.option.$model.id || this.option.$model.uid;
    },
  },
  methods: {
    onRemoveOption: function () {
      this.$emit('removeOption', this.optionId, this.option.$model.variable_id);
    },
    onCancelRemove: function () {
      this.$emit(
        'cancelRemoveOption',
        this.optionId,
        this.option.$model.variable_id
      );
    },
    validateState: function (name) {
      const { $dirty, $error } = this.option[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>

<style scoped></style>
